import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import UserContext from "../context/UserContext";
import "../styles/Nav.css";

const Nav = ({ menuOpen, toggleMenu }) => {
  const { authUser } = useContext(UserContext);
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/");
  };

  return (
    <nav>
      <div className="nav-header">
        
      </div>

      <div className={`nav-buttons ${menuOpen ? "open" : ""}`}>
        {authUser === null ? (
          <>
           <Link style={{display: "none"}} className="nav-link" to="/editmedia">Services</Link>
          </>
        ) : (
          <>
            {authUser && <span className="welcome-text">Welcome {authUser.name}</span>}
            <Link className="nav-link" to="/authenticated">Home</Link>
            {authUser.email === "support@editfarmer.com" && (
              <>
                <Link className="nav-link" to="/farmertv">FarmerTv</Link>
                <Link className="nav-link" to="/theadministrator">Admin</Link>
                 <Link className="nav-link" to="/editmedia">Services</Link>
              </>
            )}

            <Link className="nav-link" to="/settings">Settings</Link>
            <Link className="nav-link" to="/signout">Log Out</Link>
          </>
        )}
      </div>

      <img
        src={hovered ? "/otherclick2.0.png" : "/clicklogo 2.0.png"}
        alt="Banner"
        className="editIcon"
        onClick={handleClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{ cursor: "pointer" }}
      />
    </nav>
  );
};

export default Nav;